import React from "react";
import bfMark from "../assets/brand/logo_3d_white_full_transparent.webp";

// Real BF icon mark (client-supplied, background removed) + coded wordmark.
// The wordmark stays coded (not the client's raster file) because that file's
// text is baked in Russian only — the coded version follows brand.line1/2/sub
// from i18n/content.js so it still switches correctly on the RU/KZ toggle.
// tone: "ink" (dark wordmark for light backgrounds) | "cream" (light wordmark for dark backgrounds)
export function BFLogo({ tone = "ink", brand, size = 42, className = "", src = bfMark }) {
  const logoWidth = size * 2.25;

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={src}
        alt="Batys Finance"
        width={logoWidth}
        height={size}
        className="shrink-0 object-contain object-left"
        style={{ width: logoWidth, height: size * 0.72 }}
      />
    </div>
  );
}
